import { Box, IconButton } from '@primer/react';
import { Modal } from '@/components/Elements';
import { Info, X } from 'phosphor-react';

interface GlobalModalProps {
  isOpen: boolean;
  isClose: () => void;
  title: string;
  primaryButtonClick?: () => void;
  secondaryButton?: {
    text: string;
    onClick: () => void;
    loading?: boolean;
  };
  disableModalClose?: boolean;
  titleIcon?: React.ReactNode;
  children?: React.ReactNode;
  secondaryButtonClick?: () => void;
  hideAllButtons?: boolean;
  showOnlyPrimaryButton?: boolean;
  buttonText?: string;
  isPrimaryButtonLoading?: boolean;
  warningModal?: boolean;
  disablePrimaryButton?: boolean;
}

export const GlobalModal: React.FC<GlobalModalProps> = ({
  isOpen,
  isClose,
  title,
  primaryButtonClick = () => {},
  secondaryButton,
  disableModalClose = false,
  titleIcon,
  children,
  secondaryButtonClick = () => {},
  hideAllButtons = false,
  showOnlyPrimaryButton = false,
  buttonText = 'Okay',
  isPrimaryButtonLoading = false,
  warningModal = false,
  disablePrimaryButton,
}) => {
  function CustomHeader() {
    return (
      <Box
        sx={{ borderBottom: '1px solid #636C76' }}
        className="p-4 flex items-center justify-between"
      >
        <Box className="flex items-center gap-2">
          {titleIcon ? titleIcon : <Info size={22} color="#fff700" />}
          <h3 className="text-lg font-semibold text-white">{title}</h3>
        </Box>
        <IconButton
          icon={X}
          aria-label="Close"
          variant="invisible"
          size="small"
          sx={{ color: 'white' }}
          disabled={disableModalClose}
          onClick={disableModalClose ? () => {} : isClose}
        />
      </Box>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={
        disableModalClose
          ? () => {
              return;
            }
          : isClose
      }
      customHeader={CustomHeader}
      buttonText={buttonText}
      primaryButtonOnClick={primaryButtonClick}
      cancelButtonOnClick={secondaryButtonClick}
      showOnlyPrimaryButton={showOnlyPrimaryButton}
      hideAllButtons={hideAllButtons}
      isPrimaryButtonLoading={isPrimaryButtonLoading}
      warningModal={warningModal}
      secondaryButton={secondaryButton}
      disableCancelButton={disableModalClose}
      disablePrimaryButton={isPrimaryButtonLoading || disablePrimaryButton}
    >
      {children}
    </Modal>
  );
};
